import React from "react";
import { createHashRouter } from "react-router-dom";
import LoginPage from "../pages/Login/LoginPage";
import HomePage from "../pages/Home/HomePage";
import AuthDataProvider from "../dataproviders/AuthDataProvider";
import MainDataProvider from "../dataproviders/MainDataProvider";
import LoginForm from "../components/login/LoginForm";
import ResetPassword from "../components/login/ResetPassword";
import ProjectList from "../components/project/ProjectList";
import ProjectDataProvider from "../dataproviders/ProjectDataProvider";
import UserManagement from "../components/user/UserManagement";
import UserDataProvider from "../dataproviders/UserDataProvider";
import ToastWrapper from "../pages/ToastWrapper/ToastWrapper";
import VesselDataProvider from "../dataproviders/VesselDataProvider";
import DeviceDataProvider from "../dataproviders/DeviceDataProvider";
import DownloadDataProvider from "../dataproviders/DownloadDataProvider";
import DetectionDataProvider from "../dataproviders/DetectionDataProvider";
import VesselManagement from "../components/vessel/VesselManagement";
import DeviceManagement from "../components/device/DeviceManagement";
import DownloadManagement from "../components/download/DownloadManagement";
import DetectionManagement from "../components/detection/DetectionManagement";
import ViewDetection from "../components/detection/ViewDetection";

const Routers = createHashRouter([
  {
    element: <AuthDataProvider />,
    children: [
        {
            element: <ToastWrapper />,
            children: [
                {
                    element: <MainDataProvider />,
                    children: [
                        {
                            path: "/",
                            element: <HomePage />,
                            children: [
                                {
                                    path: "projects",
                                    element: <ProjectDataProvider />,
                                    children: [
                                        {
                                            path: "",
                                            element: <ProjectList />,
                                        },
                                    ],
                                },
                                {
                                    path: "users",
                                    element: <UserDataProvider />,
                                    children: [
                                        {
                                            path: "",
                                            element: <UserManagement />,
                                        },
                                    ],
                                },
                                {
                                    path: "vessels",
                                    element: <VesselDataProvider />,
                                    children: [
                                        {
                                            path: "",
                                            element: <VesselManagement />,
                                        },
                                    ],
                                },
                                {
                                    path: "devices",
                                    element: <DeviceDataProvider />,
                                    children: [
                                        {
                                            path: "",
                                            element: <DeviceManagement />,
                                        },
                                    ],
                                },
                                {
                                    path: "downloads",
                                    element: <DownloadDataProvider />,
                                    children: [
                                        {
                                            path: "",
                                            element: <DownloadManagement />,
                                        },
                                    ],
                                },
                                {
                                    path: "clusters",
                                    element: <DetectionDataProvider />,
                                    children: [
                                        {
                                            path: "",
                                            element: <DetectionManagement />,
                                        }
                                    ],
                                },
                                {
                                    path: "detections",
                                    element: <DetectionDataProvider />,
                                    children: [
                                        {
                                            path: "",
                                            element: <ViewDetection />,
                                        },
                                    ],
                                }
                            ],
                        },
                    ],
                },
                {
                    path: "/login",
                    element: <LoginPage />,
                    children: [
                        {
                            path: "",
                            element: <LoginForm />,
                        },
                        {
                            path: "resetpassword",
                            element: <ResetPassword />,
                        },
                    ],
                },
            ]
        }
    ],
  },
]);

export default Routers;
